import { useEffect, useState } from 'react';
import { Link, NavLink, Route, Routes, useLocation } from 'react-router-dom';
import { api, getAdminToken, setAdminToken } from './api';
import type { Chapter } from './types';
import { Home } from './pages/Home';
import { ChapterPage } from './pages/ChapterPage';
import { Assignments } from './pages/Assignments';
import { Cheatsheet } from './pages/Cheatsheet';
import { Admin } from './pages/Admin';
import { Library } from './pages/Library';
import { NoMatch } from './pages/NoMatch';

export default function App() {
  const [chapters, setChapters] = useState<Chapter[]>([]);
  const [token, setToken] = useState(getAdminToken());
  const location = useLocation();

  const reload = () => api.listChapters().then(setChapters).catch(() => {});

  useEffect(() => {
    reload();
  }, []);

  return (
    <div className="layout">
      <aside className="sidebar">
        <h1>CIS5300 · NLP</h1>
        <div className="sub">yuntian.blog notes</div>

        <NavLink to="/" end className="nav-link">Overview</NavLink>
        <NavLink to="/library" className="nav-link">📚 SLP3 Library</NavLink>
        <NavLink to="/assignments" className="nav-link">Assignments</NavLink>
        <NavLink to="/cheatsheet" className="nav-link">Cheatsheet</NavLink>
        <NavLink to="/admin" className="nav-link">Admin</NavLink>

        <div className="muted" style={{ marginTop: 12 }}>Chapters</div>
        <div className="chapter-list">
          {chapters.map((c) => (
            <NavLink
              key={c.id}
              to={`/chapter/${c.id}`}
              className={({ isActive }) =>
                'nav-link' + (isActive ? ' active' : '')
              }
            >
              <span className="num">{c.number}.</span>
              {c.title}
            </NavLink>
          ))}
          {!chapters.length && (
            <div className="muted" style={{ padding: '6px 10px' }}>
              No chapters yet — go to{' '}
              <Link to="/admin">Admin</Link> to add one.
            </div>
          )}
        </div>

        <div style={{ marginTop: 'auto', fontSize: 12 }} className="col">
          <div className="muted">Admin token</div>
          <input
            type="text"
            value={token}
            placeholder="paste admin token"
            onChange={(e) => {
              setToken(e.target.value);
              setAdminToken(e.target.value);
            }}
          />
        </div>
      </aside>

      <main className="main" key={location.pathname}>
        <Routes>
          <Route path="/" element={<Home chapters={chapters} />} />
          <Route
            path="/chapter/:id"
            element={<ChapterPage onChange={reload} />}
          />
          <Route path="/library" element={<Library />} />
          <Route path="/assignments" element={<Assignments chapters={chapters} />} />
          <Route path="/cheatsheet" element={<Cheatsheet chapters={chapters} />} />
          <Route
            path="/admin"
            element={<Admin chapters={chapters} onChange={reload} />}
          />
          <Route path="*" element={<NoMatch />} />
        </Routes>
      </main>
    </div>
  );
}
